// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mgYDpdumadBZuhUvsKpU {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.LvWVe233nkCI9YBSw87k {
    width: 48px;
    height: 48px;
    border-radius: 48px;
    margin-right: 8px;

    object-fit: contain;
    background-color: white;
}

.mgYDpdumadBZuhUvsKpU button + button {
    margin-left: 16px;
}

.hbCamk3ovfxL9ylx0TIc {
    text-align: right;
}

.E4YXlp5Wgw7d4a1v3yqH {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
    border-radius: 32px;
    padding: 4px 8px;
    text-align: center;
    width: max-content;
    min-width: 75px;
    font-weight: 500;
}

.E4YXlp5Wgw7d4a1v3yqH.U0W44IK5LFUGSpdUJbCb {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]};
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-light"]};
}

.YzD6iglrzDKFQj34yW5W .LvWVe233nkCI9YBSw87k {
    background: #e2e2e2;
    color: transparent;
    position: relative;
    overflow: hidden;
}

.YzD6iglrzDKFQj34yW5W .bOgR7Pl5bYBYXysBPU1y,
.YzD6iglrzDKFQj34yW5W.hbCamk3ovfxL9ylx0TIc,
.YzD6iglrzDKFQj34yW5W.E4YXlp5Wgw7d4a1v3yqH,
.YzD6iglrzDKFQj34yW5W .H_92xdJtkTvwS2cXdZ6w {
    height: 18px;
    background: #e2e2e2;
    color: transparent;
    position: relative;
    overflow: hidden;
}

.YzD6iglrzDKFQj34yW5W.hbCamk3ovfxL9ylx0TIc {
    width: 75px;
    margin-left: auto;
}

.YzD6iglrzDKFQj34yW5W.E4YXlp5Wgw7d4a1v3yqH {
    width: 75px;
    height: 18px !important;
    padding: 0;
    border-radius: 0;
}

.YzD6iglrzDKFQj34yW5W .bOgR7Pl5bYBYXysBPU1y {
    width: 150px;
}

.YzD6iglrzDKFQj34yW5W .H_92xdJtkTvwS2cXdZ6w {
    width: 100px;
}

.H_92xdJtkTvwS2cXdZ6w + .H_92xdJtkTvwS2cXdZ6w {
    margin-left: 8px;
}

.YzD6iglrzDKFQj34yW5W .LvWVe233nkCI9YBSw87k::before,
.YzD6iglrzDKFQj34yW5W .H_92xdJtkTvwS2cXdZ6w::before,
.YzD6iglrzDKFQj34yW5W .bOgR7Pl5bYBYXysBPU1y::before,
.YzD6iglrzDKFQj34yW5W.E4YXlp5Wgw7d4a1v3yqH::before,
.YzD6iglrzDKFQj34yW5W.hbCamk3ovfxL9ylx0TIc::before {
    content: "";
    position: absolute;
    left: -50%;
    top: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(to right, #e2e2e2 25%, #d5d5d5 50%, #e2e2e2 100%);
    animation-name: BCi5luTliYx4qq_6C_zO;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    filter: blur(5px);
}

.lNJ_eVeo6KLWl3u4H4Eg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;

    width: 100%;
    min-height: calc(100vh - 72px);

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: rgba(255, 255, 255, 0.75);
}

.KSXUmMPmcCbIy0li_NCV {
    background: white;
    border-radius: 5px;
    box-shadow: -1px 6px 14px 4px #ededed8f;

    padding: 32px;
    width: 50%;
    max-width: 480px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.KSXUmMPmcCbIy0li_NCV > div {
    max-height: 35vh;
}

.v1_ChmJlgQyzoivOyHDo, .v1_ChmJlgQyzoivOyHDo a {
    font-size: 15px;
    margin-top: 0;
}

.wWPxIpDUTwZlbGXKFa9B {
    margin: 0 8px 16px;
    font-size: 18px;
    text-align: center;
}

@keyframes BCi5luTliYx4qq_6C_zO {
    from {
        left: -50%;
    }
    to {
        left: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardOpportunity/DashboardOpportunityTableRow/DashboardOpportunityTableRow.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;;IAEjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mDAAmB;IACnB,8DAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mDAAuB;IACvB,8DAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;;IAII,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;IAKI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,WAAW;IACX,6EAA6E;IAC7E,oCAAkC;IAClC,sBAAsB;IACtB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;;IAEZ,WAAW;IACX,8BAA8B;;IAE9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;;IAEvC,aAAa;IACb,UAAU;IACV,gBAAgB;;IAEhB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-error-dark, color-error-light from colors;\n\n.row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.logo {\n    width: 48px;\n    height: 48px;\n    border-radius: 48px;\n    margin-right: 8px;\n\n    object-fit: contain;\n    background-color: white;\n}\n\n.row button + button {\n    margin-left: 16px;\n}\n\n.number {\n    text-align: right;\n}\n\n.status {\n    color: color-purple;\n    background-color: color-purple-bg;\n    border-radius: 32px;\n    padding: 4px 8px;\n    text-align: center;\n    width: max-content;\n    min-width: 75px;\n    font-weight: 500;\n}\n\n.status.red {\n    color: color-error-dark;\n    background-color: color-error-light;\n}\n\n.skeleton .logo {\n    background: #e2e2e2;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.skeleton .society,\n.skeleton.number,\n.skeleton.status,\n.skeleton .button {\n    height: 18px;\n    background: #e2e2e2;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.skeleton.number {\n    width: 75px;\n    margin-left: auto;\n}\n\n.skeleton.status {\n    width: 75px;\n    height: 18px !important;\n    padding: 0;\n    border-radius: 0;\n}\n\n.skeleton .society {\n    width: 150px;\n}\n\n.skeleton .button {\n    width: 100px;\n}\n\n.button + .button {\n    margin-left: 8px;\n}\n\n.skeleton .logo::before,\n.skeleton .button::before,\n.skeleton .society::before,\n.skeleton.status::before,\n.skeleton.number::before {\n    content: \"\";\n    position: absolute;\n    left: -50%;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(to right, #e2e2e2 25%, #d5d5d5 50%, #e2e2e2 100%);\n    animation-name: gradient-animation;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    filter: blur(5px);\n}\n\n.modalBackground {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n\n    width: 100%;\n    min-height: calc(100vh - 72px);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-color: rgba(255, 255, 255, 0.75);\n}\n\n.modal {\n    background: white;\n    border-radius: 5px;\n    box-shadow: -1px 6px 14px 4px #ededed8f;\n\n    padding: 32px;\n    width: 50%;\n    max-width: 480px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal > div {\n    max-height: 35vh;\n}\n\n.link, .link a {\n    font-size: 15px;\n    margin-top: 0;\n}\n\n.title {\n    margin: 0 8px 16px;\n    font-size: 18px;\n    text-align: center;\n}\n\n@keyframes gradient-animation {\n    from {\n        left: -50%;\n    }\n    to {\n        left: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-error-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]}`,
	"color-error-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-light"]}`,
	"row": `mgYDpdumadBZuhUvsKpU`,
	"logo": `LvWVe233nkCI9YBSw87k`,
	"number": `hbCamk3ovfxL9ylx0TIc`,
	"status": `E4YXlp5Wgw7d4a1v3yqH`,
	"red": `U0W44IK5LFUGSpdUJbCb`,
	"skeleton": `YzD6iglrzDKFQj34yW5W`,
	"society": `bOgR7Pl5bYBYXysBPU1y`,
	"button": `H_92xdJtkTvwS2cXdZ6w`,
	"gradient-animation": `BCi5luTliYx4qq_6C_zO`,
	"modalBackground": `lNJ_eVeo6KLWl3u4H4Eg`,
	"modal": `KSXUmMPmcCbIy0li_NCV`,
	"link": `v1_ChmJlgQyzoivOyHDo`,
	"title": `wWPxIpDUTwZlbGXKFa9B`
};
export default ___CSS_LOADER_EXPORT___;
